export const goggleLanguagesListEndpoint = 'language/getAllLanguages';
export const addTranslationLanguageEndpoint = 'language/addSurveyLanguages';
export const deleteTranslationLanguageEndpoint = 'language/deleteSurveyLanguage';
export const updateTranslatedQuestionHeadersEndpoint = 'translation/updateQuestionTranslation';
export const updateTranslatedOptionHeadersEndpoint = 'translation/updateOptionTranslation';
export const updateTranslatedSectionHeadersEndpoint = 'translation/updateSectionTranslation';
export const updateTranslatedSectionSettingEndpoint = 'translation/update-questionSettings';
export const updateMultipleOpinionSectionTextEndpoint = 'translation/multiple-opinion-scale/section-translation';
export const downloadMultiLingualCsv = 'translations/export';
export const uploadMultiLingualCsvEndpoint = 'translations/upload';
export const defaultButtonsDataEndpoint = 'survey-ui-texts/default-buttons';
export const editTranslatedButtonsDataEndpoint = 'survey-ui-texts/editTranslation';
export const updateTranslatedSectionButtonSettingEndpoint = 'translation/updatequestionSectionSettings';
export const updateLanguageStatusEndpoint = 'language/updateSurveyLanguage';
